module.exports = __webpack_public_path__ + "media/images/front/top/dplus-17336aca0e5a1f8cb3e89cc48f30c40a.png";